var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-wrapper"},[_c('b-alert',{staticClass:"text-center custom-alert",attrs:{"show":!!_vm.mensagem,"variant":_vm.cor,"dismissible":""},on:{"dismissed":function($event){return _vm.$emit('close')}}},[_c('span',{staticClass:"alert-text"},[_vm._v(_vm._s(_vm.mensagem))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }